import { makeStyles } from '@material-ui/core/styles';

export const useRowStyles = makeStyles(() => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  cell: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  image: {
    width: 108,
    height: 68,
  },
  info: {
    '& :not(:last-child)': {
      marginBottom: 5,
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export const useExchangeDesktopStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
  },
}));
